import { Box } from "@mui/material";
import Layout from "../../../layouts";
import { ReportDataTable } from "../ReportDataTable";
import { ReportProvider } from "../../../contexts/ReportContext";
import { ReportMenu } from "../ReportMenu";

export const ReportSummary = () => {
  return (
    <>
      <ReportProvider>
        <Layout>
          <Box
            display={"flex"}
            flexDirection={"column"}
            height={"100%"}
            bgcolor={"var(--white)"}
            overflow={"auto"}
          >
            <ReportMenu />
            <Box
              p={"40px 40px"}
              display={"flex"}
              flexDirection="column"
              gap={"40px"}
              flex={1}
            >
              <Box flex={1} display={"flex"} width={"100%"}>
                <ReportDataTable reportDataTableType="summary" />
              </Box>
            </Box>
          </Box>
        </Layout>
      </ReportProvider>
    </>
  );
};
